export const hemaltologic = (() => {
    const placeHolderText = 'No abnormal bleeding or lymph nodes.'

    return placeHolderText
})